import * as FeatherIcons from 'react-icons/fi';

export type IconName = keyof typeof FeatherIcons;

interface SafeIconProps {
  name: IconName;
  size?: number;
  className?: string;
}

export default function SafeIcon({ name, size = 17, className = '' }: SafeIconProps) {
  const Icon = FeatherIcons[name] ?? FeatherIcons.FiAlertTriangle;
  return <Icon size={size} className={className} aria-hidden="true" />;
}
